import { Backdrop, Box, Button, Modal, Typography } from '@mui/material';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { bulkDelete } from 'features/lotlist/bulkDeleteSlice';
import { selectSorting } from 'features/lotlist/filterAndSortSlice';
import { getLotList } from 'features/lotlist/lotListSlice';
import { selectLotListTab, selectPageLotList, selectRowsPerPageLotList } from 'features/table/tableSlice';
import { selectUserRole } from 'features/user/userSlice';
import React, { useContext } from 'react';
import { lotListTabNames, ModalContext } from '../LosListe';

interface BulkDeleteModalProps {
  checkedBoxes: string[];
  searchQuery?: string;
}

const BulkDeleteModal: React.FC<BulkDeleteModalProps> = (props) => {
  const { checkedBoxes, searchQuery } = props;
  const dispatch = useAppDispatch();
  const userRole = useAppSelector(selectUserRole);
  const rowsPerPage = useAppSelector(selectRowsPerPageLotList);
  const page = useAppSelector(selectPageLotList);
  const tab = useAppSelector(selectLotListTab);
  const sort = useAppSelector(selectSorting)
  const { modalOpened, handleClose } = useContext(ModalContext);
  const handleDelete = () => {
    dispatch(
      bulkDelete({
        ids: checkedBoxes,
        endpoint: userRole
      })
    ).then(() => {
      dispatch(
        getLotList({
          items_per_page: rowsPerPage,
          page: page + 1,
          search: searchQuery,
          status: lotListTabNames[tab],
          sort: sort,
        })
      );
      handleClose(true)
    }).catch((e) => {
      console.error(e)
    });
  }
  return (
    <Backdrop sx={{ zIndex: 1200 }} open={modalOpened}>
      <Modal hideBackdrop open={modalOpened} onClose={() => handleClose()} aria-labelledby="modal-title">
        <Box sx={{
          width: "30%",
          minWidth: "300px",
          maxWidth: "90%",
          position: "absolute",
          top: "50%",
          left: "50%",
          backgroundColor: "white",
          transform: "translate(-50%, -50%)",
          borderRadius: "16px",
          display: "flex",
          flexDirection: "column",
          gap: 2,
          padding: 4,
          textAlign: "center",
        }}>
          <Typography fontSize={20} fontWeight={"bold"}>
            Wollen Sie alle markierten Lose ({checkedBoxes.length}) unwiderbringlich löschen?
          </Typography>
          <Box sx={{
            display: "flex",
            flexDirection: "row",
            gap: 2,
            justifyContent: "space-between",
          }}>
            <Button
              onClick={() => {
                handleClose()
              }}
              sx={{
                flexGrow: 1,
                borderRadius: "26px",
                color: "#072D26",
                fontWeight: "bold",
                border: "2px solid #C0D904",
                height: "51px",
                paddingLeft: "50px",
                paddingRight: "50px",
                "&:hover": { background: "#c0d904" }
              }}>
              Abbrechen
            </Button>
            <Button
              onClick={() => {
                handleDelete()
              }}
              sx={{
                flexGrow: 1,
                borderRadius: "26px",
                color: "#072D26",
                fontWeight: "bold",
                border: "2px solid #fe0000",
                background: "#fe0000",
                height: "51px",
                paddingLeft: "50px",
                paddingRight: "50px",
                "&:hover": { background: "#cb0000" }
              }}>
              Bestätigen
            </Button>
          </Box>
        </Box>
      </Modal>
    </Backdrop>
  );
};

export default BulkDeleteModal;